import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BehaviorSubjectCollectionService {
  public isUserLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}
}
